export function lastIndexOf<V>(arr: V[], cb: (item: V) => boolean) {
  for (let i = arr.length - 1; i > -1; i -= 1) {
    if (cb(arr[i])) return i;
  }
  return -1;
}
